import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    () => localStorage.getItem("terra_lang") || "bg"
  );

  const toggleLang = () => {
    const next = lang === "en" ? "bg" : "en";
    localStorage.setItem("terra_lang", next);
    setLang(next);
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);

export default LanguageContext;
